import CustomMedia from 'util/custom-media-query';
import FontStyles from 'constants/font-styles';
import Colors from 'constants/colors';

export const pcStyle = CustomMedia.greaterThan('umedium')`
  table {
    width: 100%;
    table-layout: fixed;

    tr {
      height: 64px;
      border-top: 1px solid ${Colors.gray3};

      &:last-of-type {
        border-bottom: 1px solid ${Colors.gray3};
      }
    }

    .row-thick {
      height: 96px;

      td {
        padding-top: 16px;
      }
    }

    .row-variable {
      min-height: 64px;

      td {
        padding: 16px;
      }
    }

    .required-cell-wrapper {
      display: flex;
      align-items: center;
    }

    th,
    td {
      text-align: left;
    }

    th {
      ${FontStyles.text8};

      width: 168px;
      padding-left: 16px;
      background-color: ${Colors.gray4};

      i {
        display: inline-block;
        margin-left: 8px;
      }
    }

    td {
      ${FontStyles.text7};

      position: relative;
      padding: 0 16px;
    }
  }
`;

export const spStyle = CustomMedia.lessThan('medium')`
  table {
    width: 100%;
    border: 0;
    table-layout: fixed;

    th,
    td {
      display: block;
      text-align: left;
      border: 0;
    }

    th {
      ${FontStyles.text8};

      display: flex;
      align-items: center;
      height: 48px;
      padding-left: 8px;
      background-color: ${Colors.gray4};
      border-top: 1px solid ${Colors.gray3};

      i {
        display: inline-block;
        margin-left: 8px;
      }
    }

    td {
      ${FontStyles.text7};

      position: relative;
      min-height: 64px;
      padding: 16px 8px;
    }

    &.confirm-table {
      border-bottom: 1px solid ${Colors.gray3};
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/OrderAggregators/styles/table.js